import { useMonaco } from "@monaco-editor/react";
import { loader } from "@monaco-editor/react";
import { useEffect } from "react";

loader.config({
  paths: {
    // Caution: When changing the path, you must also update
    // the `package.json` file
    // Moreover, don't change the path without `vs` at the end as some
    // of the script are hardcoded to use this path
    vs: "/monaco/0.35.0/vs",
  },
});

export default function useConfigMonaco(builtTypeDefinitions: string) {
  const monaco = useMonaco();

  useEffect(() => {
    monaco?.languages.typescript.javascriptDefaults.setCompilerOptions({
      lib: ["es2015"],
      target: monaco.languages.typescript.ScriptTarget.ES2015,
      allowNonTsExtensions: true, // As we are loading from memory
      allowJs: true,
    });
    monaco?.languages.typescript.javascriptDefaults.setExtraLibs([
      { content: builtTypeDefinitions },
    ]);
  }, [monaco, builtTypeDefinitions]);
}
